<!-- Header -->
<div mat-dialog-title>
    {{broadcast.Title}}
</div>

<!-- Body -->
<mat-dialog-content>
    <tyl-quill-text-only [padding]="0"
        [html]="broadcast.Description"></tyl-quill-text-only>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>

    <!-- Right -->
    <div class="flex-footer-right">
        <tyl-button image="Cancel.png"
            label="Close"
            [attr.tylerastid]="'CloseBroadcastWindow'"
            (clickEvent)="close()"></tyl-button>
    </div>
</mat-dialog-actions>
